import * as React from 'react';
import * as agui from 'arm-gui/dist/controls';

class TestCoolNumberInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            valore: "9876"
        };
        this.handleChange = this.handleChange.bind(this);
        this.componentName = "[TestCoolNumberInput.jsx] ";
    }

    handleChange(val) {
        console.log(this.componentName + "handleChange");
        this.setState({ value: val });
        let log = document.getElementById('log');
        log.insertAdjacentHTML('beforeend', '<h1> value </h1> ' + this.state.value);

    }
    render() {
        console.log(this.componentName + "render");
        return (
            <div className="col-md-3" >
                <agui.CoolNumberInput
                    label="lallalallal"
                    value={this.state.value}
                    onChange={(val) => this.handleChange(val)} suffix="EUR" />
                <div id="log"></div>
            </div>
        );
    }
}
export default TestCoolNumberInput;